import React, { useEffect, useRef } from 'react';
import ConversationMessage from './ConversationMessage';

export default function ConversationThread({ messages }) {
  const endRef = useRef(null);

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages?.length]);

  return (
    <div className="conversation-thread">
      {messages?.map((msg, idx) => (
        <ConversationMessage key={idx} msg={msg} />
      ))}
      <div ref={endRef} />
    </div>
  );
}
